import { useEffect } from "react";
import { useContent } from "../hooks/useContent";
import { Button } from "./ui/Button";
import { getCookie, setCookie } from "../utils/cookies";
import { logger } from "../lib/log.utils";

const HeroSection = ({ onEnrollClick }) => {
	const { data: content } = useContent();
	const hero = content?.hero;

	useEffect(() => {
		// create or read visitor id cookie
		let vid = getCookie("visitor_id");
		if (!vid) {
			// simple random id
			vid =
				(typeof crypto !== "undefined" && crypto.randomUUID
					? crypto.randomUUID()
					: "v_" + Date.now() + "_" + Math.random().toString(16).slice(2));
			setCookie("visitor_id", vid, 365);
		}

		// send visit to backend
		(async () => {
			try {
				await fetch(`${process.env.REACT_APP_API_BASE_URL}/track-visit`, {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ visitorId: vid }),
				});
			} catch {
				logger.error("Failed to track visit");
			}
		})();
	}, []);

	return (
		<section className="relative min-h-screen flex items-center justify-center overflow-hidden">
		<div
			className="absolute inset-0 bg-cover bg-center bg-no-repeat"
			style={{
			backgroundImage: `url("${
				hero?.heroImageUrl
			}")`,
			}}
		/>
		<div className="absolute inset-0 bg-maroon-deep/60" />

		<div className="absolute inset-0 pointer-events-none">
			{[...Array(20)].map((_, i) => (
				<div
					key={i}
					className="absolute w-1 h-1 rounded-full bg-gold/60 animate-float"
					style={{
						left: `${Math.random() * 100}%`,
						top: `${Math.random() * 100}%`,
						animationDelay: `${Math.random() * 3}s`,
						animationDuration: `${2 + Math.random() * 3}s`,
					}}
				/>
			))}
		</div>

		<div className="relative z-10 text-center px-4 max-w-3xl mx-auto">
			<div className="text-gold text-4xl mb-4 font-display">🌿</div>

			<h1 className="text-5xl sm:text-7xl md:text-8xl font-display font-bold text-gold-gradient mb-4 tracking-wide leading-tight">
				{hero?.title || "Experience the Joy of Dance"}
			</h1>

			<p className="text-cream/90 font-heading text-xl sm:text-2xl tracking-widest mb-2">
				{hero?.subtitle || "Dance Classes, Balipara"}
			</p>

			<div className="flex flex-col sm:flex-row gap-4 justify-center">
				<Button
					variant="hero"
					size="lg"
					className="px-10 py-6 text-lg"
					onClick={onEnrollClick}
				>
					{hero?.primaryCta || "Join Us Today"}
				</Button>
				<Button onClick={() => {
					window.location.href = "#courses";
				}} variant="hero-outline" size="lg" className="px-10 py-6 text-lg">
					{hero?.secondaryCta || "View Courses"}
				</Button>
			</div>
		</div>

		<div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent" />
		</section>
	);
};

export default HeroSection;
